module.exports = __webpack_public_path__ + "media/images/arrow_down-c1e388839c0becad69c36444d4e6dc67.svg";